import { render, staticRenderFns } from "./FbaOrderDetail.vue?vue&type=template&id=3da2f9f5&scoped=true"
import script from "./FbaOrderDetail.vue?vue&type=script&lang=js"
export * from "./FbaOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./FbaOrderDetail.vue?vue&type=style&index=0&id=3da2f9f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2f9f5",
  null
  
)

export default component.exports